import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import ProofOfPickupDeliveryTimezone from "./ProofOfPickupDeliveryTimezone";

export type ProofOfDeliveryLocationProps = Readonly<{
  isOffPlatform: boolean;
  locationLabel: string;
  timezoneOffset: string;
  country?: string;
}>;

export default function ProofOfDeliveryLocation({
  isOffPlatform,
  locationLabel,
  timezoneOffset,
  country,
}: ProofOfDeliveryLocationProps) {
  return (
    <Row>
      <Col md="6">
        {!isOffPlatform ? (
          <>
            <div className="text-sm text-secondary-v2 font-medium mb-xs">
              <FormattedMessage id="components.molecules.top-nav.deliveryLocation" defaultMessage="Delivery location" />
            </div>
            <div className="text-md text-primary">
              {locationLabel} ({timezoneOffset})
            </div>
          </>
        ) : (
          <ProofOfPickupDeliveryTimezone country={country ?? ""} name="delivery_timezone" />
        )}
      </Col>
    </Row>
  );
}
